import {formatDateLocalized} from '@sollapay/utils';

import type {FirmMemberDTO} from '@sollapay/types';
import type {ExportColumn} from '@sollapay/web-core';
import type {TFunction} from 'i18next';

export function createTeamExportColumns(t: TFunction, lang: string): ExportColumn<FirmMemberDTO>[] {
  return [
    {header: t('columns.member'), value: row => row.name ?? row.email},
    {header: t('columns.email'), value: row => row.email},
    {header: t('columns.role'), value: row => t(`common:roles.${row.roleKey}`)},
    {header: t('columns.status'), value: row => t(`status.${row.status}`)},
    {
      header: t('columns.createdAt'),
      value: row => formatDateLocalized(row.createdAt, lang)
    }
  ];
}
